/* eslint-disable */
import { callStatic, MediaListResponse } from 'services/api-service'

/**
 * List of media
 *
 * @method
 * @name ApiService#mediaList
 * @param {string} skus -
 * @param {integer} offset -
 * @param {integer} limit -
 * @param {string} sort - Possible values are: MOST_VOTES, MOST_RECENT, and LONGEST
 * @param {boolean} includeProductSiblings -
 * @param {string} tags -
 * @param {integer} minCharCount -
 * @param {integer} minWordCount -
 * @param {boolean} includeSyndicated -
 */
function mediaList(parameters: {
  skus: string
  offset: number
  limit: number
  sort: 'MOST_VOTES' | 'MOST_RECENT' | 'LONGEST'
  includeProductSiblings: boolean
  tags: string
  minCharCount: number
  minWordCount: number
  includeSyndicated: boolean
}): Promise<MediaListResponse> {
  return callStatic<MediaListResponse>(
    '/sitedata/{siteKey}/gallery/{skus}/{locale}/{offset}/{limit}/{sort}/{minCharCount}/{minWordCount}/{includeSyndicated}/{includeProductSiblings}/{tags}',
    parameters,
    [
      'skus',
      'offset',
      'limit',
      'sort',
      'includeProductSiblings',
      'tags',
      'minCharCount',
      'minWordCount',
      'includeSyndicated'
    ]
  )
}

export default { mediaList }
